<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-form :model="searchItem" label-width="auto" inline size="small">
        <el-form-item label="用户ID">
          <el-input v-model.trim="searchItem.user_id" clearable></el-input>
        </el-form-item>
        <el-form-item label="所属商家">
          <el-input v-model.trim="searchItem.shop_name" clearable></el-input>
        </el-form-item>
        <el-form-item label="上网账号">
          <el-input v-model.trim="searchItem.username" clearable></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model.trim="searchItem.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model.trim="searchItem.remark" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户状态">
          <el-select v-model="searchItem.status" clearable>
            <el-option v-for="item in accountStatus" :key="item.id" :value="item.id" :label="item.msg"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="在线状态">
          <el-select v-model="searchItem.online" clearable>
            <el-option v-for="item in userOnline" :key="item.id" :value="item.id" :label="item.msg"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号来源">
          <el-select v-model="searchItem.create_type" clearable>
            <el-option v-for="item in accountSource" :key="item.id" :value="item.id" :label="item.msg"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model.trim="searchItem.phone" clearable></el-input>
        </el-form-item>
        <el-form-item label="套餐名称">
          <el-input v-model.trim="searchItem.package_name" clearable></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model.trim="searchItem.email" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="shopName" slot-scope="{row}">
          <template v-if="row.shop">
            <el-button class="black" type="text" @click="$router.push({path: '/shop/list', query: {shop_id: row.shop_id}})">
              {{row.shop.name}}
            </el-button>
          </template>
          <template v-else>-</template>
        </template>
        <template slot="actionBar">
          <el-table-column align="center" label="操作栏" :resizable="false" width="70">
            <template slot-scope="scope">
              <el-button type="text" class="danger" @click="statusSingle(scope.row)" v-if="scope.row.status === 0">禁用</el-button>
              <el-button type="text" class="success" @click="statusSingle(scope.row)" v-else-if="scope.row.status === 1">启用</el-button>
            </template>
          </el-table-column>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"/>
    </el-footer>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import Statistics from "@view/components/Statistics"
  import {userOnline,accountType,accountSource,accountStatus,authType,bindType} from "@utils/formatList"
  export default {
    name: "userList",
    mixins: [PagingData],
    components: {Statistics},
    data() {
      return {
        accountSource,
        userOnline,
        accountStatus,
        // 查询项
        searchItem: {
          user_id: "",
          shop_name: "",
          username: this.$route.query.username || "",
          name: "",
          remark: "",
          online: "",
          status: "",
          create_type: "",
          mobile: "",
          package_name: "",
          email: "",
        },
        commitItem: null,
        // 统计
        countList: [
          {name: "总帐号", count: 0},
          {name: "在线", count: 0, color: "#0cca8e"},
          {name: "到期", count: 0, color: "#FEBA47"},
          {name: "禁用", count: 0, color: "#909399"},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "用户ID", property: "id", width: 70},
            {label: "所属商家", property: "shopName"},
            {label: "上网账号", property: "username"},
            {label: "手机号", property: "phone"},
            {label: "姓名", property: "name"},
            {label: "在线状态", property: "online", width: 80, format: userOnline},
            {label: "账号状态", property: "status", width: 80, format: accountStatus},
            {label: "认证方式", property: "auth_method", width: 100, format: authType},
            {label: "允许登录数", property: "concurrency", width: 100},
            {label: "所属设备/组", property: "device_group", remark: "customProp"},
            {label: "当前套餐", property: "package_name", remark: "customProp"},
            {label: "套餐到期时间", property: "package_end_at", width: 160, remark: "customProp"},
            {label: "注册时间", property: "create_at", width: 160},
          ],
          // 开启展开项
          hasExpand: true,
          expandLabelWidth: 120,
          expandColumn: [
            {label: "所属商家", property: "shop.name"},
            {label: "上网账号", property: "username"},
            {label: "上网密码", property: "password"},
            {label: "账号类型", property: "type", format: accountType},
            {label: "账号来源", property: "create_type", format: accountSource},
            {label: "在线状态", property: "online", format: userOnline},
            {label: "账号状态", property: "status", format: accountStatus},
            {label: "认证方式", property: "auth_method", format: authType},
            {label: "允许登录数", property: "concurrency"},
            {label: "所属设备/组", property: "device_group", remark: "customProp"},
            {label: "套餐名", property: "package_name", remark: "customProp"},
            {label: "套餐到期时间", property: "package_end_at", remark: "customProp"},
            {label: "套餐出售截止日期", property: "package_expire_at", remark: "customProp"},
            {label: "IP绑定", property: "ip", format: bindType, remark: "customProp"},
            {label: "MAC绑定", property: "mac", format: bindType, remark: "customProp"},
            {label: "VLANID绑定", property: "vlan_id", format: bindType, remark: "customProp"},
            {label: "姓名", property: "name"},
            {label: "手机号", property: "phone"},
            {label: "身份证号", property: "id_number"},
            {label: "证件有效期", property: "validity_period"},
            {label: "签发机关", property: "issuing_authority"},
            {label: "QQ", property: "qq"},
            {label: "邮箱", property: "email"},
            {label: "地址", property: "address"},
            {label: "备注", property: "remark"},
            {label: "初装费(￥)", property: "installation_cost"},
          ]
        },
      }
    },
    methods: {
      /**单个操作*/
      //单个修改状态
      statusSingle(row) {
        let status = row.status===1 ? 0 : 1;
        let msg = row.status===1 ? "启用" : "禁用";
        this.openConfirm(`${msg}该用户`, async ()=> {
          let nv = {
            status,
            optionId: row.id,
          };
          let res = await this.$Http.reviseUser(nv);
          if (res) {
            this.msgSuccess(`${msg}成功`);
            this.getTableList();
          }
        });
      },
      /**其他*/
      // 查询
      search() {
        this.commitItem = {...this.searchItem};
        this.pagingData.currentPage = 1;
        this.getTableList();
      },
      //获取表格数据
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize
        };
        // 添加筛选项
        this.copyObjValue(nv, this.commitItem);
        let res = await this.$Http.getUserList(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.countList[1].count = +res.data.online_num || 0;
          this.countList[2].count = +res.data.expire_num || 0;
          this.countList[3].count = +res.data.paused_num || 0;
          let list = this.getArray(res.data.list);
          this.tableData.tableList = this.customProp(list);
        }
      },
      //自定义属性
      customProp(list) {
        list.forEach(item => {
          let list = item.upacks || [{}];
          item['package_end_at'] = list[0]?.end_at;
          item['package_expire_at'] = list[0]?.expire_at;
          item['package_name'] = list[0]?.name;
          item['package_price'] = list[0]?.price;
          item['package_id'] = list[0]?.package_id;
          item['device_group'] = item?.device?.name || item?.group?.name || "全部设备";
          item['ip'] = item.ip || item.bind_ip;
          item['mac'] = item.mac || item.bind_mac;
          item['vlan_id'] = +item.vlan_id || item.bind_vlan_id;
        });
        return list;
      }
    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>

</style>
